import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "master";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const masterActions = { ...slice.actions, ...extraActions };
export const masterReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    rolesList: {},
    getAllActiveUsersResponse: {},
    getAllActiveUsersForSearchResponse: {},
    committeePageActiveTab: "home",
    getCommitteeListResponse: {},
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    updateCommitteePageActiveTab,
  };

  function updateCommitteePageActiveTab(state, action) {
    state.committeePageActiveTab = action?.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;
  return {
    getRolesList: getRolesList(),
    getAllActiveUsers: getAllActiveUsers(),
    getAllActiveUsersForSearch: getAllActiveUsersForSearch(),
    getCommitteeList: getCommitteeList(),
  };

  /* get Roles */
  function getRolesList() {
    return createAsyncThunk(
      `${name}/getRolesList`,
      async () => await fetchWrapper.get(`${baseUrl}/users/getAllRoles`)
    );
  }

  /* get user list for drop down */
  function getAllActiveUsers() {
    return createAsyncThunk(
      `${name}/getAllActiveUsers`,
      async () => await fetchWrapper.get(`${baseUrl}/users/getAllActiveUsers`)
    );
  }
  /* get user list for drop down */
  function getAllActiveUsersForSearch() {
    return createAsyncThunk(
      `${name}/getAllActiveUsersForSearch`,
      async () =>
        await fetchWrapper.get(
          `${baseUrl}/users/getAllActiveCommitteeAdminUsers`
        )
    );
  }

  /* get committee list for drop down */
  function getCommitteeList() {
    return createAsyncThunk(
      `${name}/getCommitteeList`,
      async () => await fetchWrapper.get(`${baseUrl}/committee/labels/private`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //get Roles List
    .addCase(extraActions.getRolesList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getRolesList.fulfilled, (state, action) => {
      state.loading = false;
      state.rolesList = action?.payload;
    })
    .addCase(extraActions.getRolesList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /* get user for dropdown */
    .addCase(extraActions.getAllActiveUsers.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getAllActiveUsers.fulfilled, (state, action) => {
      state.loading = false;
      state.getAllActiveUsersResponse = action?.payload;
    })
    .addCase(extraActions.getAllActiveUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    /* get user for dropdown for search */
    .addCase(extraActions.getAllActiveUsersForSearch.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getAllActiveUsersForSearch.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getAllActiveUsersForSearchResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.getAllActiveUsersForSearch.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    /* get committe list for dropdown */
    .addCase(extraActions.getCommitteeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteeList.fulfilled, (state, action) => {
      state.loading = false;
      state.getCommitteeListResponse = action?.payload;
    })
    .addCase(extraActions.getCommitteeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
